import { useLocation } from 'react-router-dom';
import { businessSchema } from './business';
import { routeMetadata } from './metadata';
import { useMetadata } from './useMetadata';

export default function RouteMetadata() {
  const location = useLocation();
  // Product data owns the product metadata, including transitions between IDs.
  const metadata = routeMetadata(location.pathname, location.search);
  if (['/', '/locales', '/sucursales'].includes(location.pathname)) metadata.structuredData = businessSchema();
  useMetadata(location.pathname.startsWith('/producto/') ? null : metadata);
  return null;
}
